import { combineReducers } from 'redux';

import auth from './auth/';
import users from './users';
import customers from './customers';
import suppliers from './suppliers';
import purchaseOrders from './purchase-orders';
import receipts from './receipts';
import purchaseInvoices from './purchase-invoices';
import costBreakdowns from './cost-breakdowns';
import quotes from './quotes';
import salesOrders from './sales-orders';
import issues from './issues';
import salesInvoices from './sales-invoices';
import products from './products';
import warehouses from './warehouses';
import stock from './stock';
import movement from './movement'
import employees from './employees';
import projects from './projects';
import materials from './materials';
import workReports from './work-reports';
import series from './series';
import stats from './stats';
import years from './years';
import geography from './geography';
import notifications from './notifications';
import alertTypes from './alert-types';
import alerts from './alerts';
import auditLog from './auditLog';

const appReducer = combineReducers({
    auth,
    notifications,
    users,
    customers,
    suppliers,
    purchaseOrders,
    receipts,
    purchaseInvoices,
    costBreakdowns,
    quotes,
    salesOrders,
    issues,
    salesInvoices,
    products,
    warehouses,
    stock,
    movement,
    employees,
    projects,
    materials,
    workReports,
    series,
    stats,
    years,
    geography,
    alertTypes,
    alerts,
    auditLog
});

const rootReducer = (state, action) => {

    // Reset redux state to default when sign-out
    if (action.type === 'SIGNOUT') {
        state = undefined;
    }

    return appReducer(state, action)
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js